import { useLocation } from 'react-router-dom'

import { getModuleSegment } from './helpers'

/**
 * Tracks the first path segment of the current location so the topbar can
 * highlight the active module.
 */
export default function useActiveModule(): string {
  const { pathname } = useLocation()

  return getModuleSegment(pathname)
}
